module.exports = __webpack_public_path__ + "static/Catch-a122dca5638a23eaee5e68c12cc41575.mp4";